import { get, post } from "Service";

const initiateOdr = (payload: any) => {
  const request = {
    subUrl: "Odr/initiate",
    data: payload,
    isAuth: false,
  };
  return post(request);
};

const respondOdr = (payload: any) => {
  const request = {
    subUrl: "Odr/respond",
    data: payload,
    isAuth: false,
  };
  return post(request);
};

const createSession = (payload: any) => {
  const request = {
    subUrl: "Odr/sessions/create",
    data: payload,
    isAuth: false,
  };
  return post(request);
};

const finalizeOdr = (payload: any) => {
  const request = {
    subUrl: "Odr/finalize",
    data: payload,
    isAuth: false,
  };
  return post(request);
};

const getOdrDocuments = (caseId: number) => {
  const request = {
    subUrl: `Odr/${caseId}/documents`,
    data: {},
    isAuth: false,
  };
  return get(request);
};

const getOdrSessions = (caseId: number) => {
  const request = {
    subUrl: `Odr/${caseId}/sessions`,
    data: {},
    isAuth: false,
  };
  return get(request);
};

const downloadNoticePdf = (caseId: number) => {
  const request: any = {
    subUrl: `Odr/${caseId}/notice-pdf`,
    isAuth: false,
    excel: true, // standard file stream trigger
  };
  return get(request);
};

const uploadOdrDocument = (caseId: number, file: File, documentType: string, uploadedByUserId: number) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("documentType", documentType);
  formData.append("uploadedByUserId", String(uploadedByUserId));

  const request = {
    subUrl: `Odr/${caseId}/upload-document`,
    data: formData,
    dataType: "form-data",
    isAuth: false,
  };
  return post(request);
};

const getOdrNeutral = (caseId: number) => {
  const request = {
    subUrl: `Odr/${caseId}/neutral`,
    data: {},
    isAuth: false,
  };
  return get(request);
};

const acceptOdrNeutral = (caseId: number, payload: { conflictDisclosureText: string }) => {
  const request = {
    subUrl: `Odr/${caseId}/neutral/accept`,
    data: payload,
    isAuth: false,
  };
  return post(request);
};

const assignOdrNeutral = (caseId: number, payload: { neutralId: number }) => {
  const request = {
    subUrl: `Odr/${caseId}/neutral/assign`,
    data: payload,
    isAuth: false,
  };
  return post(request);
};

const getEligibleProfessionals = (role: string) => {
  const request = {
    subUrl: `Odr/professionals/eligible?role=${encodeURIComponent(role)}`,
    data: {},
    isAuth: false,
  };
  return get(request);
};

const assignOdrRole = (professionalId: number, role: string) => {
  const request = {
    subUrl: `Odr/professionals/${professionalId}/assign-role`,
    data: { role },
    isAuth: false,
  };
  return post(request);
};

const removeOdrRole = (professionalId: number, role: string) => {
  const request = {
    subUrl: `Odr/professionals/${professionalId}/remove-role`,
    data: { role },
    isAuth: false,
  };
  return post(request);
};

const assignOdrNeutralBatch = (payload: { caseIds: number[]; neutralId: number }) => {
  const request = {
    subUrl: "Odr/neutral/assign-batch",
    data: payload,
    isAuth: false,
  };
  return post(request);
};

const updateOdrCustomStatus = (caseId: number, payload: { customStatus: string }) => {
  const request = {
    subUrl: `Odr/${caseId}/custom-status`,
    data: payload,
    isAuth: false,
  };
  return post(request);
};

const OdrApi = {
  initiateOdr,
  respondOdr,
  createSession,
  finalizeOdr,
  getOdrDocuments,
  getOdrSessions,
  downloadNoticePdf,
  uploadOdrDocument,
  getOdrNeutral,
  acceptOdrNeutral,
  assignOdrNeutral,
  getEligibleProfessionals,
  assignOdrRole,
  removeOdrRole,
  assignOdrNeutralBatch,
  updateOdrCustomStatus,
};

export default OdrApi;

